import { Product } from "../../types/types";
import { AvailableOption } from "../../types/prodcatBaseTypes";

export const isSupplierDirect = (product: Product): boolean => {
  return getSupplierDirectOption(product) !== null;
};

export const getSupplierDirectOption = (
  product: Product,
): AvailableOption | null => {
  const dmsIds = ["14", "410", "411", "412", "418", "419", "420", "422"];
  const availableOptions = product.fulfilmentOptions?.available ?? [];

  return (
    availableOptions.find((option) =>
      dmsIds.includes(option?.aliases?.dmsId),
    ) || null
  );
};
